<template>
  <div class="activityList">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>已邀请完成参观登记的客户名单</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="operas">
      <el-button type="primary" :style="buttonStyle" @click="Export"><a href=""></a>导出列表</el-button>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="psjComName" label="企业名称"></el-table-column>
      <el-table-column prop="psjName" label="姓名"></el-table-column>
      <el-table-column prop="psjCountry" label="国家/地区"></el-table-column>
      <!--<el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-button @click="edit(scope.row)" type="text" size="small">修改</el-button>
          <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  name: 'activityList',
  data() {
    return {
      tableData: [],
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {}
    }
  },
  mounted() {
    this.getData()
  },

  methods: {
    addActive(val) {
      this.$router.push('/activityList/edit')
    },
    edit(val){
      this.$router.push({path: '/activityList/edit', query: {id: val.atyID}});
    },
    getData(){
      api.getvisitorlist({
        pageIndex: 1,
        pageSize: 20,
        token:localStorage.getItem('token')
      }).then((res) => {      
        if(res.data.code == '200'){
          var _data = res.data.data
            this.tableData = _data.list
        }
      })
    },
    Export(){
      api.downloadvisitor({
        token:localStorage.getItem('token')
      }).then((res) => {      
        if(res.data.code == '200'){
//        api.outputFile(res.data.data.url)
          var eleLink = document.createElement('a');
          eleLink.download = res.data.data.url;
          eleLink.style.display = 'none';
          eleLink.href = res.data.data.url
          document.body.appendChild(eleLink);
          eleLink.click();
          document.body.removeChild(eleLink);
        }
      })
    },
      del(val){
        this.$confirm('确定删除该活动？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          api.deleteactivity({atyID: parseInt(val.atyID) }).then(res => {
            if (res.data.code === 200) {
              this.$notify({
                title: '成功',
                message: '删除成功',
                type: 'success'
              });
              this.getData()
            }
          })
        }).catch(() => {});
    }
  }
}
</script>

<style lang="less" scoped>
.activityList{
  .operas{
    text-align: right;
    padding: 20px 0;
  }
  .cardItem{
      -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      display: flex;
      margin-bottom: 50px;
      padding: 20px;
      border-radius: 10px;
  }
  .cardItem .img{
      width:200px;
      height:200px;
      margin-right: 10px;
      text-align: center;
  }
  .cardItem .img img{
      max-width:100%;
      max-height:100%;
  }
  .rightBox{
    width: 65%;
    font-size:14px;
    position: relative;
    padding: 14px;
    p{
      padding-top:15px;
    }
    .bottom{
        padding-top: 20px;
    }
  }
  
  .mart30{
    padding-top:30px;
  }
  .blue{
    color:#409EFF
  }
  .cards{
    display: flex;
    flex-wrap: wrap;
    >li{
      padding: 0 20px;
      width: 50%
    }
  }
  @media screen and (max-width:540px){
    .cards>li{
      width: 100%;
      padding:0;
      .img{
        width:100px;
        height: auto;
      }
    }
    .rightBox{
      padding:0;
      font-size: 14px;
      >p{
        padding-top:10px;
      }
      .el-button{
        padding:8px 16px;
      }
    }
  }
}
</style>
